/**
 * Toggle Picture-in-Picture for a video element using the native browser API.
 */
export function togglePiP(video: HTMLVideoElement) {
  if (document.pictureInPictureElement === video) {
    document.exitPictureInPicture();
  } else {
    video.requestPictureInPicture();
  }
}

/**
 * Check if PiP is supported.
 */
export function isPiPSupported(): boolean {
  return "pictureInPictureEnabled" in document;
}
